import { Link, Outlet } from "react-router-dom";
import { smarteriseLogo } from "../assets/logo";
import { IoIosLogOut } from "react-icons/io";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { logout as appLogout, selectAuthSlice } from "../store/authSlice";
import { IconWrapper } from "../customHooks/useIcon";
import { ROLE } from "../utils/constants";

function OtherLayout() {
  const { logout } = useAuth0();
  const dispatch = useAppDispatch();
  const handleLogout = () => {
    logout({
      logoutParams: { returnTo: `${window.location.origin}/auth/login` },
    });
    dispatch(appLogout());
  };
  const userInfo = useAppSelector(selectAuthSlice).user;
  return (
    <div className="auth-layout-bg min-h-[100vh] overflow-hidden">
      <div className="bg-white bg-opacity-90 min-h-[100vh] h-full p-[40px] flex flex-col gap-[30px]">
        <div className="flex justify-between items-center">
          <Link
            to={userInfo?.access_level === ROLE.ADMIN ? "/" : "/sbee"}
            className="h-20"
          >
            <img
              src={smarteriseLogo}
              alt="Smarterise"
              className="cursor-pointer max-w-[170px]"
            />
          </Link>
          <button
            onClick={handleLogout}
            className="text-gray-700 hover:text-red-600"
          >
            <IconWrapper icon={IoIosLogOut} size={25} />
          </button>
        </div>
        <div className="flex-1 flex flex-col items-center justify-center h-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default OtherLayout;
